import WPBaseDAO from "./WPBaseDao";
import WPFaqModel from "../../model/WPFaqModel";
import WPPaginaModel from "../../model/WPPaginaModel";

class WPPaginaDAO extends WPBaseDAO {
  private static instance: WPPaginaDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): WPPaginaDAO {
    if (!WPPaginaDAO.instance) {
      WPPaginaDAO.instance = new WPPaginaDAO();
    }
    return WPPaginaDAO.instance;
  }

  public async getFAQ(): Promise<WPFaqModel[]> {
    return this.get(
      "REQ_WP_FAQ",
      `${this.endpoint}/loop-faq.php`
    ).then((r: any) =>
      Promise.all(r.data.map((i: any) => WPFaqModel.toModel(i)))
    );
  }

  public async getPolPrivOba(): Promise<WPPaginaModel[]> {
    return this.getPaginaWP("REQ_WP_PAG_POL_PRIV_OBA", 370); // página Política de Privacidade – OBA HORTIFRUTI = 370
  }

  public async getPolPrivBQ(): Promise<WPPaginaModel[]> {
    return this.getPaginaWP("REQ_WP_PAG_POL_PRIV_BQ", 6468); // página Política de Privacidade – CLIENTE BEM QUERER = 6468
  }

  public async getTermosCondicoesBQ(): Promise<WPPaginaModel[]> {
    return this.getPaginaWP("REQ_WP_PAG_TC_PROG_BQ", 11); // Termos e Condições de uso do Programa CLIENTE BEM QUERER = 11
  }

  public async getRegProgBQ(): Promise<WPPaginaModel[]> {
    return this.getPaginaWP("REQ_WP_PAG_REG_PROG_BQ", 10); // Regulamento do programa CLIENTE BEM QUERER = 10
  }

  private async getPaginaWP(
    label: string,
    codigoPagina: number
  ): Promise<WPPaginaModel[]> {
    return this.get(
      label,
      `${this.endpoint}/loop-pagina.php?tipoConsulta=porID&idPagina=${codigoPagina}`
    ).then((r: any) =>
      Promise.all(r.data.map((i: any) => WPPaginaModel.toModel(i)))
    );
  }
}

export default WPPaginaDAO;
